
import { Image, Modal, Pressable, StyleSheet, Text, View } from "react-native";
import { color_333333, color_main, ColorLine, white } from "../../assets/style/colors";
import { useWindowDimensions } from 'react-native';
import { ImageView } from "../../components/ImageView";
import { postJson } from "../../net/http";
import { useEffect, useState } from "react";
import { Str_accountBindingNotice, Str_dontRemind, Str_loginGuide } from "../../language/string_res";
import { isIos } from "../../AppEvent";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { useStore } from "../../store/UserStore";
import { useIsFocused } from "@react-navigation/native";
import { CheckBoxView } from "../../components/CheckBoxView";


export interface LoginGuideProps {
    visible: boolean;
    uid: number
    onClose: () => void;
}
export const LoginGuideModal = (props: LoginGuideProps) => {
    const { width: screenWidth } = useWindowDimensions();
    const [isChecked, setIsChecked] = useState(false);
    const { state } = useStore()
    const isfocus = useIsFocused()
    useEffect(() => {
        if (isfocus && (state?.user.remail || state?.user.rtel)) {
            AsyncStorage.setItem(`${props.uid}-LoginGuide`, "")
            props.onClose()
        }
    }, [isfocus, state?.user.remail, state?.user.rtel])

    const onClose = () => {
        if (isChecked) {
            postJson<any>('/v1/sdk/user/loginguide/off', {
                useToken: true,
                debug: true
            }).then(r => { })
            AsyncStorage.setItem(`${props.uid}-LoginGuide`, "")
        }
        props.onClose()
    }
    const toggleCheck = () => setIsChecked((prev) => !prev);

    if (state?.user.remail || state?.user.rtel) {
        return (<></>)
    }
    return (<Modal
        animationType="fade"
        transparent={true}
        statusBarTranslucent={true}
        visible={props.visible}
    >
        <View style={styles.modalBackdrop}>
            <View style={[styles.popupContainer, { width: screenWidth - 40 }]}>
                <View style={{
                    flexDirection: 'row',
                    marginBottom: 15,
                    height: 46,
                    alignItems: 'center', width: '100%',
                    justifyContent: 'center',
                }}>
                    <Text style={styles.popupTitle}>{Str_loginGuide}</Text>
                    <ImageView
                        style={{ padding: 16, position: 'absolute', end: 20 }}
                        source={require('../../assets/image/icon_dialog_close.png')}
                        onClick={onClose} imgStyle={{ width: 16, height: 16 }} />
                </View>


                <Text style={styles.popupText}>{Str_accountBindingNotice} </Text>
                <View style={{ height: 0.5, width: '100%', backgroundColor: ColorLine, marginTop: 20 }} />
                <Pressable style={{ flexDirection: 'row', alignItems: 'center', marginTop: 10, padding: 10 }}
                    onPress={toggleCheck}>
                    <CheckBoxView
                        value={isChecked}
                        style={{ width: 15, height: 15 }}
                        onValueChange={setIsChecked}
                    />
                    <Text style={{ marginLeft: isIos ? 8 : 18, fontSize: 14, color: '#979797' }}>{Str_dontRemind}</Text>
                </Pressable>

            </View>
        </View>
    </Modal >);
}

const styles = StyleSheet.create({
    buttonContainer: {
        paddingHorizontal: 16,
        paddingBottom: 0,
        paddingTop: 12,
        backgroundColor: white,
    },
    popupButtonText: {
        color: white,
        fontSize: 16,
        fontWeight: '600',
        fontFamily: '',
    },
    popupButton: {
        backgroundColor: color_main,
        paddingVertical: 14,
        borderRadius: 6,
        alignItems: 'center',
        width: '100%',
        marginBottom: 0,
    },
    popupContent: {
        paddingHorizontal: 20,
        paddingTop: 20,
    },
    // 协议弹窗
    modalBackdrop: {
        flex: 1,
        backgroundColor: "rgba(0,0,0,0.5)",
        justifyContent: 'center',
        alignItems: 'center',
    },
    popupContainer: {
        backgroundColor: white,
        borderRadius: 10,
        maxHeight: '80%',
        marginHorizontal: 16,
        alignItems: 'center',
        paddingTop: 20,
        paddingBottom: 10
    },
    popupTitle: {
        fontSize: 20,
        fontWeight: 'bold',
        fontFamily: '',
        color: color_333333,
        textAlign: 'center',
    },
    popupText: {
        fontSize: 14,
        color: color_333333,
        marginHorizontal: 30,
        lineHeight: 20,
        paddingBottom: 16,
    },
})